import React from 'react'
import Layout from 'layouts/Layout'
import * as schemas from 'utils/schema.js'

import EpodSlideshow from 'components/products/EpodSlideshow'
import Portal from 'components/Portal'
import { ScrollProvider } from 'components/ScrollContext'
import MetaTags from 'components/MetaTags'

export default function Epod() {
  return (
    <Layout hideHeader hideFooter hideWarning>
      <Portal selector="scripts">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas.epod) }} />
      </Portal>
      <MetaTags
        title="ePod Starter Kit ➡️ Shop our E-Cigarette Online | By Vuse"
        description="Compact and stylish, discover ePod, a vape that offers a wide choice of flavours and is available in multiple color choices! Shop now! Previously govype.ca"
      />
      <ScrollProvider initialStep="#step-1" categories={['#step-1', '#step-2', '#step-6', '#step-7']}>
        <EpodSlideshow />
      </ScrollProvider>
    </Layout>
  )
}
